import { render, staticRenderFns } from "./TourGuide.vue?vue&type=template&id=7ec447a8&slot-scope=tour"
import script from "./TourGuide.vue?vue&type=script&lang=js"
export * from "./TourGuide.vue?vue&type=script&lang=js"
import style0 from "./TourGuide.vue?vue&type=style&index=0&id=7ec447a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports